import type { UserMap } from '~/models'

export async function updateMapPreferences({
  initialViewState,
  searchView,
}: {
  initialViewState?: UserMap['initialViewState']
  searchView?: UserMap['searchView']
}) {
  const response = await fetch('/api/set-map-home', {
    body: JSON.stringify({ initialViewState, searchView }),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  })

  if (!response.ok) {
    throw new Error('Failed to save map preferences')
  }
}
